export default __webpack_public_path__ + "static/media/04AW2FEB66.2176e258.jpg";